import Bugsnag, { NotifiableError } from '@bugsnag/js'

const currencyToSymbolMap: { [key: string]: string } = {
  USD: '$',
  EUR: '€',
  GBP: '£',
  JPY: '¥',
  AUD: 'A$',
  CAD: 'C$',
  CHF: 'CHF',
  CNY: '¥',
  HKD: 'HK$',
  NZD: 'NZ$',
  SEK: 'kr',
  KRW: '₩',
  SGD: 'S$',
  NOK: 'kr',
  MXN: '$',
  INR: '₹',
  RUB: '₽',
  ZAR: 'R',
  TRY: '₺',
  BRL: 'R$',
  TWD: 'NT$',
  DKK: 'kr',
  PLN: 'zł',
  THB: '฿',
  IDR: 'Rp',
  HUF: 'Ft',
  CZK: 'Kč',
  ILS: '₪',
  PHP: '₱',
  AED: 'د.إ',
  COP: '$',
  SAR: '﷼',
  MYR: 'RM',
}

export const getCurrencySymbol = (currency: string) => {
  return currencyToSymbolMap[currency] || currency
}

export const formatCurrencyAmount = (amount = 0, currency = 'USD') => {
  const formattedAmount = amount.toFixed(2)
  const currencySymbol = getCurrencySymbol(currency)

  return `${currencySymbol}${formattedAmount}`
}

export const formatCurrency = (
  amount?: string | number,
  currency = 'USD',
  locale = 'en',
  options?: Intl.NumberFormatOptions,
  allowZero = false, // it's kind of backwards but as a default behavior we return null
  //  for 0 to avoid returning a truthy value based on uninitialized or partially initialized data
) => {
  if (!amount && !(allowZero && amount === 0)) return null

  try {
    return Number(amount).toLocaleString(locale, {
      style: 'currency',
      currency,
      ...options,
    })
  } catch (e) {
    console.error('Error formatting currency: ', e)
    Bugsnag.notify(e as NotifiableError)

    return 'Curr. format err'
  }
}
